module.exports = __webpack_public_path__ + "static/media/code4.b65633e2.PNG";